import PropTypes from 'prop-types';

const MicOnIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.882 18C41.052 18 42 19.002 42 20.238c0 9.672-6.82 17.658-15.652 18.874v4.524h3.13c1.153 0 2.087.977 2.087 2.182S30.631 48 29.478 48H19.043c-1.152 0-2.086-.977-2.086-2.182s.934-2.182 2.086-2.182h3.13v-4.46C13.09 38.208 6 30.1 6 20.238 6 19.002 6.948 18 8.118 18s2.117 1.002 2.117 2.238c0 8.042 6.163 14.558 13.765 14.558 7.603 0 13.765-6.517 13.765-14.558 0-1.236.948-2.238 2.117-2.238zM24 0c4.97 0 9 4.321 9 9.65v10.7c0 5.327-4.035 9.65-9 9.65-4.97 0-9-4.32-9-9.643V9.637C15 4.317 19.035 0 24 0z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

MicOnIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

MicOnIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default MicOnIcon;
